import { create } from 'apisauce';

import { ApiError } from '../../helpers/errors';

/**
 * @typedef {Object} PaymentMethod
 * @property {number} id
 * @property {string} label
 * @property {string} icon
 * @property {string} translation_key
 */

/**
 * Create the global configuration API
 */
const globalConfigurationApi = create({
  baseURL: process.env.REACT_APP_TILLER_GLOBAL_CONFIGURATION_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_TILLER_GLOBAL_CONFIGURATION_API_TOKEN,
  },
});

/**
 * Retrieve payment methods from the api
 *
 * @return {Promise<PaymentMethod[]>} an array of payment methods
 * @throws {ApiError} if an error occur with api call
 */
export const retrievePaymentMethods = async () => {
  const { ok, problem, data } = await globalConfigurationApi.get('/payment-methods');

  if (!ok) {
    throw new ApiError(problem);
  }

  return data.response;
};
